// @flow

import React from 'react';
import type { Node } from 'react';

import {
  embeddedGmapsCls,
  embeddedGmapsCanvasCls,
  embeddedGmapsIFrameCls,
} from 'shared_components/common/embedded/maps/Google.less';

type Props = {
  address: string,
  width?: number | string,
  height?: number | string,
};

/**
 * EmmbeddedGoogleMaps
 *
 * @param {Prop} prop
 */
export function EmmbeddedGoogleMaps({ address, width = '100%', height = '100%' }: Props): Node {
  return (
    <div className={embeddedGmapsCls}>
      <div className={embeddedGmapsCanvasCls}>
        <iframe
          title="Google Maps"
          width={width}
          height={height}
          className={embeddedGmapsIFrameCls}
          id="gmap_canvas"
          src={`https://maps.google.com/maps?q=${encodeURI(
            address,
          )}&t=&z=13&ie=UTF8&iwloc=&output=embed`}
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
        />
      </div>
    </div>
  );
}
